module.exports = __webpack_public_path__ + "media/images/sp/specials/fair_event/gallery/tmb_gallery10-bbadbfeacc73faa1efe2254b99d2ee2f.jpg";